// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISortVariant {
  /** Значение для варианта сортировки **/
  key: EKey;
  /** Отображаемый текст варианта сортировки  **/
  value: string;
}

export enum EKey {
  /** По общей площади **/
  'Area' = 'area',
  /** По умолчанию **/
  'Default' = 'default',
  /** По площади участка **/
  'LandArea' = 'landArea',
  /** По расстоянию до МКАД **/
  'Mkad' = 'mkad',
  /** По цене **/
  'Price' = 'price',
  /** По цене за квадратный метр **/
  'SquarePrice' = 'squarePrice',
  /** По улице **/
  'StreetName' = 'streetName',
  /** По времени до метро **/
  'WalkingTime' = 'walkingTime',
}
